import { zergApi } from "@/service/zerg";


class AttendanceService {

    async getEmployeeAttendance(payload) {
        try {
            const data = await zergApi.post('/rrhh/schedule/get-employee-mark-schedule', payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getHolidays(payload) {
        try {
            const data = await zergApi.post('/rrhh/schedule/get-holidays', payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getPersonalWorkingDays(payload) {
        try {
            const data = await zergApi.post('/rrhh/schedule/get-personal-working-days', payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

}

export default new AttendanceService();